import React from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import moment from 'moment'
import { Grid, Segment } from 'semantic-ui-react'
import { LKDate } from 'loankeeper-common/helpers/Date'
import { withLivedata } from 'shared'
import { LKHeader } from 'loankeeper-common/components'
//@ts-ignore
import LKModal, { LKModalContainer, actions as LKModalActions } from 'shared/LKModal'
//@ts-ignore
import { GridContainer, FakeInput } from 'shared/StyledComponents'
//@ts-ignore
import LKButton from 'shared/LKButton'
//@ts-ignore
import { reactForm, FormField } from 'shared/reactForm'
import { actions as DCActions } from '../../DetailsContainer'
import { translateIDDoc as translate, translateLKMessage, translateNotes } from '../helpers'
import { openFileDetails } from '../../FileDetails'
import { IDDocModalFormValues, IDDocModalProps, IDDocModalState } from '../types'
import { clinetAddIdDoc, clinetEditIdDoc, getClientSelects } from 'src/store/client'
import { AppDispatch } from 'src/store/index.d'
import { ClinetAddIdDocParams, ClinetEditIdDocParams } from '@lk/api'

export const MODAL_NAME = 'AddEditClientIDDocModal'

const StyledGridContainer = styled(GridContainer)`
  .linked-files-container {
    padding-right: 0;
    text-align: left;
    width: 550px;

    .lk-form-field {
      width: calc(100% - 36px);
    }
  }
`

const previewExtenstions = ['jpg', 'png', 'pdf']

@LKModalContainer(MODAL_NAME)
//@ts-ignore
@withLivedata('OpenDayStatus.Open_Day_Str as OpenDayStr')
@reactForm({
  initialValues: ({ OpenDayStr }: { OpenDayStr: string }) => ({
    Active: true,
    IDCardTypeID: 1,
    IDCardIssuerID: 1,
    IDCardIssuerTxt: '',
    IDNumber: '',
    IssueDate: OpenDayStr,
    ExpireDate: LKDate.from(LKDate.from(OpenDayStr).instance.clone().add(1, 'years')).toString(),
    HasExpireDate: true,
    DFDoc: true,
    LFLID: 0,
    HashSum_FileID_: '',
  }),
  validate: (values: IDDocModalFormValues, { OpenDayStr }: { OpenDayStr: string }) => {
    const ERR_REQUIRED_FIELD = translateLKMessage('ERR_REQUIRED_FIELD')

    const errors = {
      IDNumber: !values.IDNumber ? ERR_REQUIRED_FIELD : undefined,
      IssueDate: !values.IssueDate || !LKDate.isValid(values.IssueDate) ? ERR_REQUIRED_FIELD : undefined,
      ExpireDate:
        values.HasExpireDate && (!values.ExpireDate || !LKDate.isValid(values.ExpireDate))
          ? ERR_REQUIRED_FIELD
          : undefined,
    }

    if (!errors.IssueDate && LKDate.from(values.IssueDate).instance > LKDate.from(OpenDayStr).instance) {
      errors.IssueDate = 'cannot be future date'
    }

    if (
      values.HasExpireDate &&
      !errors.ExpireDate &&
      LKDate.from(values.ExpireDate).instance < LKDate.from(OpenDayStr).instance
    ) {
      errors.ExpireDate = 'cannot be past date'
    }

    return errors
  },
})
//@ts-ignore
@connect(undefined, {
  openErrorModal: (message: string) => LKModalActions.openError(translateLKMessage(message)),
  fetchPage: (ID: string | number, hash: string) =>
    DCActions.fetchPage({
      type: 'Client',
      ID,
      hash,
      page: 'iddocs',
    }),
  openFileDetails,
})
//@ts-ignore
@connect(undefined, (dispatch: AppDispatch) => ({
  getClientSelects: () => dispatch(getClientSelects()),
  clinetAddIdDoc: (params: ClinetAddIdDocParams) => dispatch(clinetAddIdDoc(params)),
  clientEditIdDoc: (params: ClinetEditIdDocParams) => dispatch(clinetEditIdDoc(params)),
}))
class IDDocModal extends React.Component<IDDocModalProps, IDDocModalState> {
  LinkedFiles: Array<{
    value: number
    text: string
    content: React.ReactNode
  }>
  constructor(props: IDDocModalProps) {
    super(props)
    //@ts-ignore
    this.LinkedFiles = props.linkedfiles.map(({ ID, Title, TypeTitle }) => ({
      value: ID,
      text: Title,
      content: (
        <div className="u-flex u-directionRow u-alignCenter">
          <div style={{ width: 50, minWidth: 50, paddingRight: 15, textAlign: 'right' }}>{ID}</div>
          <div style={{ width: 330, minWidth: 320, paddingRight: 15, textAlign: 'left' }}>{TypeTitle}</div>
          <div>{Title}</div>
        </div>
      ),
    }))
    this.LinkedFiles.unshift({
      value: 0,
      text: '-- No File Selected -- ',
      content: (
        <div className="u-flex u-directionRow u-alignCenter">
          <div style={{ width: 50, minWidth: 50, paddingRight: 15, textAlign: 'right' }}>--</div>
          <div style={{ width: 330, minWidth: 320, paddingRight: 15, textAlign: 'left' }}>--</div>
          <div>--</div>
        </div>
      ),
    })
  }

  state = { fetching: false, IDCardtype: [], Cardissuer: [] }

  componentDidMount() {
    this.LoadLookups()

    const { form, params } = this.props

    if (params && params.data) {
      const { data } = params

      form.initialize({
        ...data,
        IssueDate: LKDate.from(data.IssueDate).toString(),
        ExpireDate: LKDate.from(data.ExpireDate).toString(),
        Active: data.Active !== 0,
        HasExpireDate: !!data.ExpireDate,
        DFDoc: !!data.DFDoc,
      })
    }
  }

  submit = (values: Partial<IDDocModalFormValues> & { ID: number | string }) => {
    const { ID, hash, params, fetchPage, closeModal, openErrorModal, linkedfiles } = this.props

    const { IDCardTypeID, IDCardIssuerID, IDCardIssuerTxt, IDNumber, IssueDate, DFDoc, LFLID } = values

    const ExpireDate = values.HasExpireDate ? values.ExpireDate : '01.01.1900'

    let fileHash: string
    if (LFLID) {
      fileHash = linkedfiles.find((lf) => lf.ID === LFLID).HashSum_FileID_
    } else fileHash = ''

    let promise: Promise<any>

    if (params && params.data) {
      // promise = Client.editIdDoc({
      //   ClientID: ID,
      //   hash,
      //   ID: values.ID,
      //   IDCardTypeID,
      //   IDCardIssuerID,
      //   IDCardIssuerTxt,
      //   IDNumber,
      //   IssueDate,
      //   ExpireDate,
      //   DFDoc,
      //   FileID: LFLID,
      //   HashSum_FileID_: fileHash,
      // })

      //UPDATED API REQUEST client_oper_api: iddocedit
      promise = this.props.clientEditIdDoc({
        ClientID: ID,
        hash,
        ID: values.ID,
        IDCardTypeID,
        IDCardIssuerID,
        IDCardIssuerTxt,
        IDNumber,
        IssueDate,
        ExpireDate,
        DFDoc,
        FileID: LFLID,
        HashSum_FileID_: fileHash,
      })
    } else {
      // promise = Client.addIdDoc({
      //   ClientID: ID,
      //   hash,
      //   IDCardTypeID,
      //   IDCardIssuerID,
      //   IDCardIssuerTxt,
      //   IDNumber,
      //   IssueDate,
      //   ExpireDate,
      //   DFDoc,
      //   FileID: LFLID,
      //   HashSum_FileID_: fileHash,
      // })

      //UPDATED API REQUEST client_oper_api: iddocadd
      promise = this.props.clinetAddIdDoc({
        ClientID: ID,
        hash,
        IDCardTypeID,
        IDCardIssuerID,
        IDCardIssuerTxt,
        IDNumber,
        IssueDate,
        ExpireDate,
        DFDoc,
        FileID: LFLID,
        HashSum_FileID_: fileHash,
      })
    }

    return promise
      .then((res) => {
        if (res?.error?.message) {
          openErrorModal(res.payload)
          return
        }
        closeModal()
        if (this.props.onSubmitSuccess) {
          this.props.onSubmitSuccess({
            ...values,
            CardType: this.state.IDCardtype.find((t) => t.value === values.IDCardTypeID).text,
            Issuer: this.state.Cardissuer.find((t) => t.value === values.IDCardIssuerID).text,
          })
        } else fetchPage(ID, hash)
      })
      .catch((e) => {
        openErrorModal(e.Error.Message || e.Error.Text)
      })
  }

  LoadLookups = async () => {
    this.setState({ fetching: true })

    // const {
    //   Data,
    // }: {
    //   Data: {
    //     [key: string]: Array<{ ID: number; Title: string }>
    //   }
    // } = await Client.getSelects()

    //UPDATED API REQUEST client_lookups_api
    const { payload: Data } = await this.props.getClientSelects()

    this.setState({
      fetching: false,
      IDCardtype: Data.IDCardtype.map(({ ID, Title }) => ({ value: ID, text: Title })),
      Cardissuer: Data.Cardissuer.map(({ ID, Title }) => ({ value: ID, text: Title })),
    })
  }

  handleHasExpireDateChange = (event: boolean, data: { checked: boolean }) => {
    const { form } = this.props
    const { IssueDate } = form.values

    form.changeValues({
      HasExpireDate: event,
      ExpireDate:
        event && IssueDate ? LKDate.from(LKDate.from(IssueDate).instance.clone().add(1, 'years')).toString() : '',
    })
  }

  handleSubmit = () => this.props.form.handleSubmit(this.submit)

  viewFile = () => {
    const { linkedfiles } = this.props
    const { values } = this.props.form

    if (values.LFLID) {
      const file = linkedfiles.find((lf) => lf.ID === values.LFLID)

      this.props.openFileDetails({ ID: file.ID, hash: file.HashSum_FileID_, type: file.Ext })
    }
  }

  canPreview = () => {
    const file = this.props.linkedfiles.find((lf) => lf.ID === this.props.form.values.LFLID)

    return file && previewExtenstions.includes(file.Ext.toLowerCase())
  }

  render() {
    const {
      modalInstanceName,
      form,
      params,
      params: { view },
    } = this.props

    return (
      <LKModal
        name={modalInstanceName}
        heading={translate('frm_client_iddoc_add_edit')}
        loading={this.state.fetching}
        size="sm-1"
        footer={
          <LKModal.Footer
            sideActions={
              !view && (
                <LKButton alias="ok" onClick={this.handleSubmit} loading={form.submitting}>
                  {translate('cmd_finish')}
                </LKButton>
              )
            }
          />
        }
        noOverflow
      >
        <StyledGridContainer>
          <Grid>
            {this.props.client && (
              <Grid.Row verticalAlign="middle">
                <Grid.Column width={5} textAlign="right">
                  {translate('lbl_firstname')}
                </Grid.Column>

                <Grid.Column width={11}>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">
                        {this.props.client.FullName} -{this.props.client.CardNumber}
                      </LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>
              </Grid.Row>
            )}

            <hr style={{ marginTop: 10, marginBottom: 10 }} />

            <Grid.Row verticalAlign="middle">
              <Grid.Column width={5} />

              <Grid.Column width={11}>
                <FormField type="checkbox" name="Active" form={form} label={translate('chk_active')} disabled />
              </Grid.Column>
            </Grid.Row>

            <Grid.Row verticalAlign="middle">
              <Grid.Column width={5} textAlign="right">
                {translate('lbl_id_Card_Type')}
              </Grid.Column>

              <Grid.Column width={11}>
                <FormField
                  type="select"
                  disabled={view}
                  name="IDCardTypeID"
                  form={form}
                  options={this.state.IDCardtype}
                />
              </Grid.Column>
            </Grid.Row>

            <Grid.Row verticalAlign="middle">
              <Grid.Column width={5} textAlign="right">
                {translate('lbl_id_card_issuer')}
              </Grid.Column>

              <Grid.Column width={11}>
                <FormField
                  type="select"
                  disabled={view}
                  name="IDCardIssuerID"
                  form={form}
                  options={this.state.Cardissuer}
                />
              </Grid.Column>
            </Grid.Row>

            <Grid.Row verticalAlign="middle">
              <Grid.Column width={5} textAlign="right">
                {translate('lbl_idcardissuertxt')}
              </Grid.Column>

              <Grid.Column width={11}>
                <FormField type="text" disabled={view} name="IDCardIssuerTxt" form={form} />
              </Grid.Column>
            </Grid.Row>

            <Grid.Row verticalAlign="middle">
              <Grid.Column width={5} textAlign="right">
                {translate('lbl_ID_number')}
              </Grid.Column>

              <Grid.Column width={11}>
                <FormField type="text" disabled={params.data} name="IDNumber" form={form} />
              </Grid.Column>
            </Grid.Row>

            <Grid.Row verticalAlign="middle">
              <Grid.Column width={5} textAlign="right">
                {translate('lbl_id_card_issue_date')}
              </Grid.Column>

              <Grid.Column width={11}>
                <FormField
                  type="date"
                  disabled={view}
                  inputProps={{ disabled: view }}
                  name="IssueDate"
                  form={form}
                  max={moment().toDate()}
                  upward
                />
              </Grid.Column>
            </Grid.Row>

            <Grid.Row verticalAlign="middle">
              <Grid.Column width={5} textAlign="right">
                {translate('lbl_id_card_expire_date')}
              </Grid.Column>

              <Grid.Column className="u-flex u-directionRow u-alignCenter" width={11}>
                <FormField
                  type="checkbox"
                  name="HasExpireDate"
                  disabled={view}
                  form={form}
                  onChange={this.handleHasExpireDateChange}
                  className="u-marginRight-10"
                />

                <FormField
                  type="date"
                  name="ExpireDate"
                  form={form}
                  min={moment().toDate()}
                  disabled={view || !form.values.HasExpireDate}
                  inputProps={{ disabled: view || !form.values.HasExpireDate }}
                  upward
                />
              </Grid.Column>
            </Grid.Row>

            <Grid.Row verticalAlign="middle">
              <Grid.Column width={5} />
              <Grid.Column width={11}>
                <FormField type="checkbox" disabled={view} name="DFDoc" form={form} label={translate('chk_dfdoc')} />
              </Grid.Column>
            </Grid.Row>

            <Grid.Row verticalAlign="middle">
              <Grid.Column width={5} textAlign="right">
                {translateNotes('lbl_file_t')}
              </Grid.Column>
              <Grid.Column className="u-flex u-directionRow u-alignCenter" width={11}>
                <div className="u-flex linked-files-container">
                  <FormField
                    type="select"
                    name="LFLID"
                    form={form}
                    disabled={view}
                    options={this.LinkedFiles}
                    menuWidth={550}
                  />

                  <LKButton
                    alias="preview"
                    className="u-marginLeft-5"
                    form={form}
                    onClick={this.viewFile}
                    disabled={!this.canPreview()}
                  />
                </div>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </StyledGridContainer>
      </LKModal>
    )
  }
}

export default IDDocModal
